export enum COOKIE_KEYS {
  APP_INI = 'appini',
  HTTP_LAST_SUCCESS = 'httpLastSuccessTime',
  IS_LOGGED_IN = 'spring-authenticated',
  JESSIONID = 'JSESSIONID',
  REFRESH_PROFILE = 'refresh-profile',
  REDIRECT = 'spring-redirect',
  SET_FROM_UI = 'front-set',
  INVALID_session_logout = 'invalid_session_logout',
  COMPARE_DEEP_LINK = 'openCompareModalOnLoad'
}
